import React, { Component } from "react";
import { connect } from "react-redux";

import PagesComponent from "./PagesComponent";

import { fetchHubPages } from "Thunks";

class Pages extends Component {
  componentDidMount() {
    const { fetchHubPages } = this.props;

    fetchHubPages({ limit: 100 });
  }

  render() {
    return <PagesComponent {...this.props} />;
  }
}
// Connected Component
const mapStateToProps = state => ({
  pages: state.pages.items,
  fetching: state.pages.fetching,
  fetched: state.pages.fetched
});

const mapDispatchToProps = dispatch => ({
  fetchHubPages: params => dispatch(fetchHubPages(params))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Pages);



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Bloc/Pages/index.js